import type { ArticleBlock, ArticleSection } from "./types";

export function createSectionIndex(sections?: ArticleSection[] | null) {
  const list = Array.isArray(sections) ? sections : [];
  const index = new Map<string, ArticleSection>();

  for (const section of list) {
    index.set(section.id, section);
    if (section.key) index.set(section.key, section);
    if (section.slug) index.set(section.slug, section);
  }

  return index;
}

export function sortSections(sections?: ArticleSection[] | null) {
  const list = Array.isArray(sections) ? sections : [];
  return [...list].sort((a, b) => {
    const aOrder = typeof a.order === "number" ? a.order : 0;
    const bOrder = typeof b.order === "number" ? b.order : 0;
    return aOrder - bOrder;
  });
}

export function groupBlocksBySection(blocks?: ArticleBlock[] | null) {
  const list = Array.isArray(blocks) ? blocks : [];
  const sorted = [...list].sort((a, b) => {
    const aOrder = typeof a.order_index === "number" ? a.order_index : 0;
    const bOrder = typeof b.order_index === "number" ? b.order_index : 0;
    return aOrder - bOrder;
  });
  const groups: Array<{ sectionId: string | null; blocks: ArticleBlock[] }> = [];
  const groupIndex = new Map<string, number>();

  for (const block of sorted) {
    const sectionId = block.sectionId ?? null;
    const key = sectionId ?? "root";
    const existingIndex = groupIndex.get(key);
    if (existingIndex !== undefined) {
      groups[existingIndex].blocks.push(block);
      continue;
    }

    groupIndex.set(key, groups.length);
    groups.push({ sectionId, blocks: [block] });
  }

  return groups;
}
